import React, { useState } from "react";

const EditTextPost = ({ post, onClose }) => {
  const [content, setContent] = useState(post.content || "");

  const handleSubmit = () => {
    // Call API here
    console.log("Updated Text Post:", content);
    onClose();
  };

  return (
    <div className="flex flex-col gap-2 p-2">
      <textarea
        className="border border-gray-300 rounded px-3 py-2 resize-none min-h-[120px]"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="What's on your mind?"
      ></textarea>
      <button
        onClick={handleSubmit}
        className="mt-2 bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
      >
        Update
      </button>
    </div>
  );
};

export default EditTextPost;
